import { useQueryClient } from "@tanstack/react-query";

import { getQueryKey } from "app/modules/api-client";

export const useAlertsRelatedQueriesInvalidation = () => {
    const queryClient = useQueryClient();

    return async (activationSetId: string) => {
        await queryClient.invalidateQueries({
            queryKey: getQueryKey({
                tag: "Alerts",
                methodName: "userdataActivationSubscriptionsAlertsDetail",
                args: [activationSetId],
            }),
            refetchType: "all",
        });
    };
};
